import { PaymentRequestStatus } from "./payment-request-status.model";

export class PaymentRequest {
  PaymentRequestId: number;
  Amount: number;
  AmountCurrency: string;
  RemittanceInformation: string;
  AuthorizationUrl: string;
  AuthorizationCode: string;
  CreatedAt: Date;
  CompletedAt: Date;
  IsExpired: boolean;
  Status: PaymentRequestStatus;
  CompanyName: string;
  IsUpgradeCreditRequest: boolean;
  IsCompleted: boolean;
  ExpirationDate: Date;
  NumberOfDaysValid: number;

  constructor(remittanceInformation?: string) {
    this.PaymentRequestId = null;
    this.Amount = null;
    this.AmountCurrency = null;

    this.RemittanceInformation = null;
    if (remittanceInformation) {
      this.RemittanceInformation = remittanceInformation;
    }

    this.AuthorizationUrl = null;
    this.AuthorizationCode = null;
    this.CreatedAt = null;
    this.CompletedAt = null;
    this.IsExpired = null;
    this.Status = null;
    this.CompanyName = null;
    this.IsUpgradeCreditRequest = false;
    this.IsCompleted = false;
    this.ExpirationDate = null;
    this.NumberOfDaysValid = null;
  }
}

export let PaymentRequestIgnoreList: any[] = [
  "Status"
];
